import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import "./base.css";

const Bakery_Secret = ({ pdfExportComponent, data, company, company2 }) => {
  // date_day
  // date_month
  // date_year
  // personal_info_name
  // personal_info_age
  // personal_info_house_No
  // personal_info_village_No
  // personal_info_lane
  // personal_info_road
  // personal_info_sub_district
  // personal_info_district
  // personal_info_province
  // personal_info_phone_number
  // detail_position
  // detail_start_date_day
  // detail_start_date_month
  // detail_start_date_year
  // detail_salary
  // detail_salary_word
  return (
    <>
      <div id="document-box" className="documents">
        <PDFExport
          ref={pdfExportComponent}
          fileName={`แบบฟอร์มประกาศเรื่องการดำเนินการกับพนักงานที่ทุจริต - ${data.personal_info_name}`}
          forcePageBreak=".page-break"
        >
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2,
              }}
            >
              <div
                id="header"
                className="text-with-bold "
                style={{
                  zIndex: 2,
                  position: "absolute",
                  //26px
                  top: "140px",
                  right: "47px",
                  fontSize: "15.5px",
                  width: "705px",
                  fontFamily: "THSarabun",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                <b
                  className="docs-font-bold"
                  style={{ textDecoration: "underline" }}
                >
                  สัญญารักษาข้อมูลทางการค้า
                </b>
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "215px",
                  right: "74px",
                  fontSize: "18px",
                  // fontFamily: "angsaLight",
                  width: "655px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "27px",
                }}
              >
                <p />
                &nbsp;&emsp;&emsp;&emsp;หนังสือฉบับนี้ทำขึ้น ที่บริษัท
                {company?.name_th}
                &nbsp;เมื่อวันที่...........เดือน....................................พ.ศ.................
                <br />
                &nbsp;&emsp;&emsp;&emsp;ข้าพเจ้านาย/นาง/นางสาว
                ….....……………………………………………........................……………………………….อายุ……..…….…….......ปี
                <br />
                อยู่บ้านเลขที่……….............……..........….หมู่ที่….............................ตรอก/ซอย…..............……..............……………...........…....……………..…..……
                <br />
                ถนน……………................................……………….............…........แขวง/ตำบล..............…………............................................………….........………..
                <br />
                เขต/อำเภอ……...……………………………............................................…..…..จังหวัด……..........…………….……...............................................….....
                <br />
                โทรศัพท์…………………………..............................................….ซึ่งต่อไปในสัญญานี้จะเรียกว่า
                “พนักงาน” ขอทำหนังสือฉบับนี้ให้ไว้แก่บริษัท {company?.name_th}
                &nbsp; (“บริษัทฯ”) เพื่อเป็นการแสดงว่า
                พนักงานรับทราบและตกลงตามข้อกำหนดต่างๆในสัญญาฉบับนี้
                ตามรายละเอียดดังต่อไปนี้
                <br />
                &nbsp;&emsp;&emsp;&emsp;ตามที่บริษัทฯ
                ได้รับพนักงานเข้าทำงานในตำแหน่ง.....................................................................................................................
                <br />
                แผนก/ฝ่าย......................................................................................................................เนื่องด้วย
                การรักษาความปลอดภัยข้อมูลทางการค้าเป็นเรื่องที่มีความสำคัญ
                การเปิดเผยข้อมูลจากภายในหรือภายนอกองค์กรไม่ว่าจะเป็นการกระทำโดยเจตนาหรือไม่เจตนาก็ตามอาจส่งผลกระทบกับการดำเนินงานของบริษัทฯ
                ดังนั้นเพื่อให้เกิดความปลอดภัย
                และความเป็นระเบียบเรียบร้อยของการเปิดเผยข้อมูลทางการค้า
                และข้อมูลต่างๆ ของบริษัทฯ พนักงาน
                รับทราบและตกลงปฏิบัติตามข้อกำหนดดังต่อไปนี้
                <br />
                &nbsp;&emsp;&emsp;&emsp; ข้อ 1.
                <u className="docs-font-bold">คำนิยาม</u>{" "}
                ในสัญญาฉบับนี้ให้มีความหมายดังต่อไปนี้
                <br />
                &nbsp;&emsp;&emsp;&emsp; “ข้อมูลทางการค้า”
                ให้หมายความถึงแต่ไม่จำกัดเฉพาะ สิ่งที่สื่อความหมายให้รู้ข้อความ
                เรื่องราว ข้อเท็จจริง หรือสิ่งใด
                ไม่ว่าการสื่อความหมายนั้นจะผ่านวิธีการใดๆและไม่ว่าจะจัดทำไว้ในรูปแบบใดๆโดยให้หมายความรวมถึงสูตร
                รูปแบบ งานที่ได้รวบรวมหรือประกอบขึ้น โปรแกรม วิธีการ เทคนิค
                หรือกรรมวิธีด้วย
                ทั้งนี้ไม่ว่าจะมีวัตถุประสงค์จะให้เป็นความลับหรือไม่ก็ตาม
                โดยให้หมายความรวมถึงข้อมูลที่ยังไม่ได้มีการเปิดเผยต่อประชาชน
                ข้อมูลที่มีไว้ใช้เพื่อวัตถุประสงค์ของบริษัทฯอย่างเดียว
                รวมตลอดถึงผลิตภัณฑ์ แบบจำลอง ตัวอย่างสินค้า การวางเกณฑ์ต่างๆ
                รายละเอียดของผลิตภัณฑ์ การออกแบบ ภาพถ่าย แบบร่าง กระบวนการผลิต
                วิธีใช้ ข้อมูลทางด้านเทคนิค ข้อมูลทางการค้า รายละเอียดทางเทคนิค
                แผนธุรกิจ ความชำนาญ ประสบการณ์ กลยุทธ์ทางธุรกิจ ปริมาณสินค้า
                ความลับทางการค้า ราคาทุน แหล่งซื้อสินค้า ข้อมูลทางการเงิน
                และการตลาด บันทึก สำเนา รายงาน การวิเคราะห์ และการตรวจสอบ ฯลฯ
                <br />
                &nbsp;&emsp;&emsp;&emsp; ข้อ 2.{" "}
                <u className="docs-font-bold">
                  การเปิดเผยข้อมูลทางการค้า และข้อมูลของบริษัทฯ
                </u>{" "}
                <br />
                &nbsp;&emsp;&emsp;&emsp;2.1
                พนักงานจะต้องไม่เปิดเผยข้อมูลทางการค้า ข้อมูลความลับทางธุรกิจ
                หรือข้อมูลที่หากเปิดเผยแล้วอาจทำให้เสียประโยชน์
                และความสามารถในการแข่งขันแก่บุคคลภายนอกบริษัทฯ ไม่ว่าจะโดยเอกสาร
                อีเมล หรือคำสั่ง การขอความอนุเคราะห์ ขอความร่วมมือใดๆ ก็ตาม
                <br />
                &nbsp;&emsp;&emsp;&emsp;2.2
                พนักงานจะต้องไม่แบ่งปันข้อมูลทางการค้ากับบุคคลอื่นที่ไม่มีส่วนเกี่ยวข้อง
                และจำเป็นต้องทราบ
                แม้ว่าจะเป็นการเปิดเผยข้อมูลระหว่างบุคคลและแผนกต่างๆภายในบริษัทฯ
                ก็ตาม
                <br />
                &nbsp;&emsp;&emsp;&emsp;2.3
                พนักงานรับทราบว่าข้อมูลทางการค้าที่เป็นความลับพนักงานต้องดำเนินการปกป้องและต้องรักษาให้มีความปลอดภัย
                ได้แก่ ข้อมูลทางการเงิน ความลับทางการค้า ตัวเลขยอดขาย
                ข้อมูลเกี่ยวกับพนักงาน ลูกค้า ผู้จัดหาสินค้า หรือบริการ
                ข้อมูลเกี่ยวกับค่าจ้างและเงินเดือน เงินรางวัลประจำปี แผนการลงทุน
                พยากรณ์ รายได้ แผนปรับปรุงผลิตภัณฑ์ ข้อมูลราคาและกำไร
                ข้อมูลเกี่ยวกับสินค้าในอนาคต การตลาด การโฆษณา
                หรือการเปลี่ยนแปลงผู้บริหาร เป็นต้น
                <br />
              </div>
            </div>
            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                id="date_day"
                className="date day docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "215px",
                  right: "345px",
                  fontSize: "18.2px",
                  width: "30px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_day}
              </div>

              <div
                id="date_month"
                className="date month docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "215px",
                  right: "215px",
                  fontSize: "18.2px",
                  width: "106px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.date_month}
              </div>

              <div
                id="date_year"
                className="date year docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "215px",
                  right: "145px",
                  fontSize: "18.2px",
                  width: "46px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.date_year}
              </div>

              <div
                id="personal_info_name"
                className="personal_info name docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "240px",
                  right: "210px",
                  fontSize: "18.2px",
                  width: "380px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
              <div
                id="personal_info_age"
                className="personal_info age docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "240.5px",
                  right: "109.6px",
                  fontSize: "18.5px",
                  width: "40px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_age}
              </div>

              <div
                id="personal_info_house_No"
                className="personal_info house_No docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "266.5px",
                  right: "574px",
                  fontSize: "18.5px",
                  width: "49px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_house_No}
              </div>
              <div
                id="personal_info_village_No"
                className="personal_info village_No docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "265.5px",
                  right: "455px",
                  fontSize: "18.5px",
                  width: "40px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_village_No}
              </div>

              <div
                id="personal_info_lane"
                className="personal_info lane docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "265.5px",
                  right: "225px",
                  fontSize: "18.5px",
                  width: "107px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_lane}
              </div>

              <div
                id="personal_info_road"
                className="personal_info road docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "292.5px",
                  right: "507px",
                  fontSize: "18.5px",
                  width: "180px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_road}
              </div>

              <div
                id="personal_info_sub_district"
                className="personal_info sub_district docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "292.5px",
                  right: "215px",
                  fontSize: "18.5px",
                  width: "94px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_sub_district}
              </div>

              <div
                id="personal_info_district"
                className="personal_info district docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "320.5px",
                  right: "500px",
                  fontSize: "18.5px",
                  width: "94px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_district}
              </div>

              <div
                id="personal_info_province"
                className="personal_info province docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "320.5px",
                  right: "192px",
                  fontSize: "18.5px",
                  width: "96px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_province}
              </div>

              <div
                id="personal_info_phone_number"
                className="personal_info phone_number docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "345.5px",
                  right: "520px",
                  fontSize: "18.5px",
                  width: "110px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_phone_number}
              </div>

              <div
                id="detail_position"
                className="detail position docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top:
                    data?.detail_position?.length >= 60
                      ? "428.5px"
                      : "428.5px",
                  right: "132px",
                  fontSize:
                    data?.detail_position?.length >= 60 ? "18px" : "15.5px",
                  width: "254px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                  // backgroundColor: "red"
                }}
              >
                {data.detail_position}
              </div>

              <div
                id="detail_department"
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "454.5px",
                  right: "373px",
                  fontSize: "18.2px",
                  width: "231px",
                  letterSpacing: 0.14,
                  textAlign: "center",
                }}
              >
                {data.detail_department}
              </div>

            </div>
          </div>
          <div
            id="page2"
            className="page-break"
            style={{ position: "absolute", top: "1150px", right: "0%" }}
          >
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "relative",
                  // top: "1150px",
                  // right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                }}
              />
              <div
                id="content"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "0px",
                  fontFamily: "THSarabun",
                  right: "0px",
                }}
              >
                <div
                  id="paragraph1"
                  className="docs-font"
                  style={{
                    zIndex: 2,
                    position: "relative",
                    top: "125px",
                    right: "47px",
                    fontSize: "15.35px",
                    width: "705px",
                    letterSpacing: 0.14,
                    textAlign: "justify",
                    lineHeight: "20px",
                  }}
                >
                  &nbsp;&emsp;&emsp;&emsp;2.4
                  พนักงานรับทราบว่าบุคคลที่สามารถเปิดเผยข้อมูลความลับของบริษัทฯ
                  คือ กรรมการผู้มีอำนาจกระทำการแทนบริษัท
                  หรือผู้ที่ได้รับมอบหมายจากกรรมการผู้มีอำนาจกระทำการแทนบริษัท
                  <br />
                  &nbsp;&emsp;&emsp;&emsp; ข้อ 3.{" "}
                  <u className="docs-font-bold">
                    การป้องกันการขัดแย้งของผลประโยชน์ และการเปิดเผยข้อมูลภายใน
                  </u>{" "}
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.1
                  พนักงานจะต้องหลีกเลี่ยงการทำรายการที่เกี่ยวโยงกับตนเอง
                  ที่อาจก่อให้เกิดความขัดแย้งทางผลประโยชน์กับบริษัทฯ
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.2 กรณีที่จำเป็นต้องทำรายการนั้น
                  เพื่อประโยชน์ของบริษัทฯ
                  พนักงานจะต้องทำรายการนั้นเสมือนการทำรายการ
                  กับบุคคลภายนอกที่มีข้อตกลงทางการค้าในลักษณะเดียวกับที่วิญญูชนพึงกระทำกับคู่สัญญาทั่วไปด้วยอำนาจต่อรองทางการค้าที่ปราศจากอิทธิพลในการที่เป็นกรรมการ
                  ผู้บริหาร หรือบุคคล ที่เกี่ยวข้อง
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.3
                  พนักงานจะต้องพิจารณารายการที่มีหรืออาจมีความขัดแย้งทางผลประโยชน์
                  (Conflicts of Interest) ระหว่างผู้ถือหุ้น กรรมการ ผู้บริหาร
                  และบุคคลอื่นที่อาจมีความขัดแย้งอื่น ซึ่งใช้แนวปฏิบัติ
                  อย่างชัดเจน
                  และเชื่อมั่นได้ว่าการเข้าทำรายการดังกล่าวมีความเป็นธรรม
                  โปร่งใส สมเหตุสมผล และเปิดเผยข้อมูลอย่างถูกต้องครบถ้วน
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.4
                  ในกรณีที่พนักงานหรือบุคคลในครอบครัวเข้าไปมีส่วนร่วมหรือเป็นผู้ถือหุ้นในกิจการที่แข่งขันกับธุรกิจของบริษัทฯ
                  หรือกิจการใดๆ
                  ที่อาจก่อให้เกิดความขัดแย้งทางผลประโยชน์กับบริษัทฯ
                  พนักงานจะต้องแจ้งให้คณะกรรมการบริษัทฯ
                  ทราบเป็นลายลักษณ์อักษรทันที
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;3.5 ระหว่างที่ปฏิบัติงานให้บริษัทฯ
                  และหลังจากพ้นสภาพการเป็นพนักงานแล้ว
                  พนักงานจะต้องไม่เปิดเผยข้อมูลทางการค้าของบริษัทฯ
                  เพื่อประโยชน์แก่ผู้ใดทั้งสิ้น ไม่ว่าจะเป็นข้อมูลอิเล็กทรอนิกส์
                  ข้อมูลการเงิน การปฏิบัติงาน ข้อมูลธุรกิจ
                  แผนงานในอนาคตของบริษัทฯ และอื่นๆ
                  <br />
                  &nbsp;&emsp;&emsp;&emsp; ข้อ 4.{" "}
                  <u className="docs-font-bold">การประพฤติผิดสัญญา</u> <br />
                  &nbsp;&emsp;&emsp;&emsp;พนักงานรับทราบว่าหากพนักงานฝ่าฝืนหรือประพฤติผิดสัญญานี้
                  ถือว่าเป็นการประพฤติผิดสัญญาจ้างอย่างร้ายแรงโดยที่พนักงานมีสิทธิพิจารณาลงโทษในขั้นร้ายแรง
                  ตั้งแต่การชำระค่าเสียหายในทางแพ่ง
                  และ/หรือตามคำพิพากษาของศาลที่กำหนดโทษจำคุก ปรับ
                  หรือโทษทางอาญาอื่นๆ รวมถึงรับโทษทางวินัยสูงสุด เช่น
                  การให้ออกจากงาน การระงับจ่ายค่าจ้าง เป็นต้น
                  <br />
                  <br />
                  &nbsp;&emsp;&emsp;&emsp;พนักงานได้อ่านและเข้าใจข้อความในสัญญานี้โดยตลอดแล้ว
                  จึงได้ลงลายมือชื่อไว้เป็นสำคัญ
                  <br />
                  <br />
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................นายจ้าง
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                  ........................................................................
                  )
                  <br />
                  <br />
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................พนักงาน
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                  ........................................................................
                  )
                  <br />
                  <br />
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................พยาน
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                  ........................................................................
                  )
                  <br />
                  <br />
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................พยาน
                  <br />
                  &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                  ........................................................................
                  )
                </div>
              </div>
            </div>

            <div id="var" className="var">
              {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                id="personal_info_name2"
                className="personal_info name2 docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "621.5px",
                  right: "310px",
                  fontSize: "15.5px",
                  width: "187px",
                  letterSpacing: 0.14,
                  fontFamily: "THSarabun",
                  textAlign: "center",
                }}
              >
                {data.personal_info_name}
              </div>
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

Bakery_Secret.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default Bakery_Secret;
